import { ENV, ENV_ENUM } from '@/shared/config';

// ISO 8601 with an explicit offset or Z; without one dayjs reads it as the viewer's local time.
export const MAINTENANCE_START_TIME =
  ENV === ENV_ENUM.customer ? '2026-11-08T08:00:00+07:00' : '2026-10-30T09:00:00+07:00';
export const MAINTENANCE_END_TIME =
  ENV === ENV_ENUM.customer ? '2026-11-08T10:00:00+07:00' : '2026-10-30T13:00:00+07:00';
